import * as React from "react";
import {
  Typography,
  ListItem,
  Box,
  Chip,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { useFeature } from "src/context/global";
// import removeIcon from "src/assets/images/settings/close-02.svg";
// import KuikwitDialog from "src/components/shared/atoms/dialog";
import DeleteIcon from "@mui/icons-material/Delete";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useState } from "react";
import clsx from "clsx";
import useStyle from "./Styles";

interface Props {
  loading: boolean;
  // removeModal: boolean;
  setRemoveModal: any;
  response: any;
  // handleResponse: any;
  handleDeleteResponse: any;
}

const Response: React.FC<Props> = ({
  response,
  // handleResponse,
  // loading,
  handleDeleteResponse,
  // removeModal,
  setRemoveModal,
}) => {
  const { classes } = useStyle();
  const [, setHovered] = useState(false);
  const { panelType } = useActiveUserDetail();
  const navigate = useNavigate();

  const { canUse } = useFeature();
  const canSavePersonalCannedResponse = canUse(
    "saving_personal_canned_responses",
  );
  const canSaveAdminCannedResponse = canUse("saving_admin_canned_responses");

  const { id, long, short, type } = response ?? "";
  const PERSONAL_TYPE = "personal";
  const SUPERADMIN = "SUPERADMIN";
  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const editResponse = () => {
    navigate(`/settings/canned-response?mode=edit`, {
      state: { response },
    });
  };

  const deleteFunc = () => {
    setRemoveModal(true);
    handleDeleteResponse(id);
  };

  // Determine if the user has permission to modify this response
  const canModify =
    type === PERSONAL_TYPE
      ? canSavePersonalCannedResponse // false means allowed
      : canSaveAdminCannedResponse; // false means allowed

  const showIcons =
    canModify && (panelType === SUPERADMIN || type === PERSONAL_TYPE);

  return (
    <ListItem
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={clsx(
        classes.listStyle,
        type === PERSONAL_TYPE ? classes.accentPersonal : classes.accentGeneric,
      )}
      disablePadding
    >
      <Box sx={{ width: "100%" }}>
        <Typography className={classes.longTextStyle} variant="body2">
          {long}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 1 }}>
          <Chip
            className={classes.shortcutTextStyle}
            label={`#${short}`}
            size="small"
          />
          <Typography
            variant="caption"
            sx={{ color: "#95a5a6", fontWeight: 600 }}
          >
            {type === PERSONAL_TYPE ? "MY RESPONSE" : "GENERIC"}
          </Typography>
        </Box>
      </Box>

      {showIcons && (
        <Box className={clsx(classes.iconBox, "action-icons")}>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={editResponse}
              sx={{ color: "#1877F2" }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              onClick={deleteFunc}
              sx={{ color: "#FF5A5F" }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </ListItem>
  );
};

export default Response;
